import React, { useEffect, useState } from 'react';
import { checkAuth } from './CheckAuth';
import DashBoardNavigation from '../../DashBoard/DashBoardNavigation';

export default function Authenticated(props) {
        const [viewField,setViewField] = useState(null);
        const autherize = async()=>{
            checkAuth()
            .then(data => {
                data?.status
                ? 
                    data.user.role === 'user'
                    ?
                    setViewField(props.children)
                    :
                    setViewField(
                        <DashBoardNavigation/>
                    )
                :
                setViewField(props.children);

                // * data is stored as a user or the admin to add that into it
            })
            .catch(error => {
                console.log(error);
            });
        }

        useEffect(()=>{
            autherize();
        }
    ,[])

    return(
        <div>
            {
                viewField
            }
        </div>
    )
}